import { useRef, useState } from "react";

import Modal from "shared/Components/modal";
import { MobilePagination } from "shared/Components/mobilePagination";
import Loader from "shared/Components/loader";
import { UserDetailCard } from "./UserDetailCard";
import { UserListCard } from "./UserListCard";
import { globalVariables } from "helper/globalVariables";

export const TrailListMobileTable = ({
  data,
  currentPage,
  totalPages,
  loading,
  error,
  handlePageChange,
}) => {
  const modalRef = useRef();
  const [selectedTrialIndex, setSelectedTrialIndex] = useState(null);

  const openModal = (e, trialIndex) => {
    e.stopPropagation();
    setSelectedTrialIndex(trialIndex);
    modalRef.current.openModal();
  };

  if (data && data.length === 0 && !loading) {
    return (
      <div className="p-4 flex justify-center items-center text-gray-600">
        <span>{globalVariables.noDataAvailable}</span>
      </div>
    );
  }

  return (
    <>
      {!loading && !error ? (
        <>
          <div className="mb-20">
            {data.map((userDetail, index) => {
              return (
                <UserListCard
                  userDetail={userDetail}
                  onViewMoreClick={(e) => openModal(e, index)}
                />
              );
            })}
          </div>

          {totalPages > 1 ? (
            <MobilePagination
              currentPage={currentPage}
              totalPages={totalPages}
              handlePageChange={handlePageChange}
            />
          ) : (
            ""
          )}
        </>
      ) : loading ? (
        <Loader stroke="text-gradient-500" />
      ) : (
        <span>{error?.message}</span>
      )}
      <Modal ref={modalRef}>
        {selectedTrialIndex !== null && (
          <UserDetailCard userDetail={data[selectedTrialIndex]} />
        )}
      </Modal>
    </>
  );
};
